import { AccordionModule } from 'primeng/accordion';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { Avatar } from 'primeng/avatar';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { CommonModule } from '@angular/common';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DragDropModule } from 'primeng/dragdrop';
import { DrawerModule } from 'primeng/drawer';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputOtpModule } from 'primeng/inputotp';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgModule } from '@angular/core';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PasswordModule } from 'primeng/password';
import { ProgressBarModule } from 'primeng/progressbar';
import { SelectModule } from 'primeng/select';
import { SplitButtonModule } from 'primeng/splitbutton';
import { Skeleton, SkeletonModule } from 'primeng/skeleton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DividerModule } from 'primeng/divider';
import { FileUploadModule } from 'primeng/fileupload';
import { TabsModule } from 'primeng/tabs';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { PickListModule } from 'primeng/picklist';
import { TooltipModule } from 'primeng/tooltip';
const modules = [
  AccordionModule,
  AutoComplete,
  AutoCompleteModule,
  Avatar,
  PickListModule,
  BreadcrumbModule,
  ButtonModule,
  CardModule,
  CheckboxModule,
  CommonModule,
  CommonModule,
  DatePickerModule,
  DialogModule,
  DividerModule,
  DragDropModule,
  DrawerModule,
  FileUploadModule,
  FloatLabelModule,
  IconFieldModule,
  InputIconModule,
  InputNumberModule,
  InputOtpModule,
  InputTextModule,
  MessageModule,
  MultiSelectModule,
  PaginatorModule,
  PanelModule,
  PasswordModule,
  ProgressBarModule,
  ScrollPanelModule,
  SelectModule,
  SplitButtonModule,
  Skeleton,
  SkeletonModule,
  TableModule,
  TagModule,
  TabsModule,
  TextareaModule,
  TimelineModule,
  ToastModule,
  ToggleButtonModule,
  ToggleSwitchModule,
  InputGroupModule,
  InputGroupAddonModule,
  TooltipModule,
];

@NgModule({
  declarations: [],
  imports: [...modules],
  exports: [...modules],
})
export class PrimengModule {}
